export const SET_NARRATIVE = 'SET_NARRATIVE'
export const SET_TAB = 'SET_TAB'
export const DISCLAIMERS_FETCH_REQUESTED = 'DISCLAIMERS_FETCH_REQUESTED'
export const DISCLAIMERS_FETCH_SUCCEEDED = 'DISCLAIMERS_FETCH_SUCCEEDED'
export const DISCLAIMERS_FETCH_FAILED = 'DISCLAIMERS_FETCH_FAILED'
export const SET_MODAL = 'SET_MODAL'
export const TRANSITION_FAILED = 'TRANSITION_FAILED'
export const TRANSITION_REQUESTED = 'TRANSITION_REQUESTED'
export const TRANSITION_SUCCEEDED = 'TRANSITION_SUCCEEDED'
export const TRANSITION_COMPLETED = 'TRANSITION_COMPLETE'
export const TRANSITION_PROPOSED = 'TRANSITION_PROPOSED'
export const USER_INFO_FETCH_FAILED = 'USER_INFO_FETCH_FAILED'
export const USER_INFO_FETCH_REQUESTED = 'USER_INFO_FETCH_REQUESTED'
export const USER_INFO_FETCH_SUCCEEDED = 'USER_INFO_FETCH_SUCCEEDED'
export const NARRATIVE_HISTORY_FETCH_REQUESTED = 'NARRATIVE_HISTORY_FETCH_REQUESTED'
export const NARRATIVE_HISTORY_FETCH_SUCCEEDED = 'NARRATIVE_HISTORY_FETCH_SUCCEEDED'
export const NARRATIVE_HISTORY_FETCH_FAILED = 'NARRATIVE_HISTORY_FETCH_FAILED'
export const NARRATIVE_HISTORY_RESET = 'NARRATIVE_HISTORY_RESET'
export const NARRATIVE_FETCH_REQUESTED = 'NARRATIVE_FETCH_REQUESTED'
export const NARRATIVE_FETCH_SUCCEEDED = 'NARRATIVE_FETCH_SUCCEEDED'
export const NARRATIVE_FETCH_FAILED = 'NARRATIVE_FETCH_FAILED'
export const DASHBOARD_FETCH_REQUESTED = 'DASHBOARD_FETCH_REQUESTED'
export const DASHBOARD_FETCH_SUCCEEDED = 'DASHBOARD_FETCH_SUCCEEDED'
export const DASHBOARD_FETCH_FAILED = 'DASHBOARD_FETCH_FAILED'
